import { useSelector } from "react-redux"
import { getParentCompanyOrCompanyName } from "reducers/companyInfo"
import { Spacer } from "../atoms/Atoms"
import React from "react"
import { HomeCard } from "./Home"
import { H2, ArrowLink } from "@carrotfertility/carotene"
import { PiiText } from "services/tracking"
import { FormattedMessage, useIntl } from "react-intl"

export default function HowToUseYourBenefitCard(): JSX.Element {
  const intl = useIntl()
  const companyName = useSelector(getParentCompanyOrCompanyName)

  const formattedMessage = intl.formatMessage(
    {
      defaultMessage: "{companyName} has partnered with Carrot to offer you a comprehensive set of benefits."
    },
    { companyName: <PiiText>{companyName}</PiiText> }
  )

  return (
    <HomeCard>
      <H2>
        <FormattedMessage defaultMessage="Your benefit guide" />
      </H2>
      <Spacer height={0.25} />
      <span className="publico-text fw4 lh-copy black-80">{formattedMessage}</span>
      <Spacer height={1} />
      <ArrowLink to="/your-benefit-guide/about-your-benefit">
        <FormattedMessage defaultMessage="Get the details" />
      </ArrowLink>
    </HomeCard>
  )
}
